import { LoginDetailSection } from 'modules';
import React from 'react';



export type LoginActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const LoginActivity = (props: LoginActivityProps) => {

  return (


    <LoginDetailSection.FC />


  );
};
